import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { IconButton } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ArticleIcon from "@mui/icons-material/Article";
import { v4 as uuidv4 } from "uuid";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  overflow: "hidden",
  cursor: "default",
  border: "1px #333 solid",
};

export default function PreviousStudiesModal(props) {
  console.log("props.studies",props.studies)
  return (
    <Box>
      <Modal
        open={true}
        onClose={() => 0}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              width: "100%",
              p: 1,
              pl: 2,
              boxShadow: 1,
              background: "#222",
              color: "#fff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Previous Studies</Typography>
            <IconButton>
              <ListAltIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              p: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid item md={12}>
                <List
                  sx={{ width: "100%", maxHeight: "400px", overflow: "auto" }}
                >
                  {props.studies.length ? (
                    <>
                      {props.studies.map((name) => (
                        <ListItem key={uuidv4()} divider disablePadding>
                          <ListItemButton>
                            <ListItemText primary={name} />
                            <ArticleIcon />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </>
                  ) : (
                    <Box
                      sx={{
                        height: "70px",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontsSize: 30,
                        fontWeight: 700,
                      }}
                    >
                      No Previous Studies to display
                    </Box>
                  )}
                </List>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              p: 2,
              boxShadow: 1,
            }}
          >
            <Grid container spacing={2}>
              <Grid item md={12}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={props.close}
                  >
                    Close
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
